export const voiceAgentsList = [
  {
    id: 1,
    name: 'Sales Assistant',
    description:
      'AI-powered voice agent that handles sales inquiries, qualifies leads, and schedules appointments with potential customers.',
    language: 'en-US',
    voice_price: 0.002,
    active: true,
    created_at: 1736033561,
  },
  {
    id: 2,
    name: 'Support Bot',
    description:
      'Customer support voice agent that provides instant help, troubleshoots issues, and escalates complex problems to human agents.',
    language: 'en-US',
    voice_price: 0.0015,
    active: true,
    created_at: 1736033562,
  },
  {
    id: 3,
    name: 'Appointment Scheduler',
    description:
      'Automated booking agent that manages calendars, confirms appointments, and sends reminders to customers.',
    language: 'en-US',
    voice_price: 0.001,
    active: true,
    created_at: 1736033563,
  },
  {
    id: 4,
    name: 'Order Tracker',
    description:
      'Voice agent specialized in providing order status updates, tracking information, and delivery estimates.',
    language: 'en-US',
    voice_price: 0.0012,
    active: false,
    created_at: 1736033564,
  },
  {
    id: 5,
    name: 'Billing Support',
    description:
      'Handles billing inquiries, payment processing questions, and account balance information for customers.',
    language: 'en-US',
    voice_price: 0.0018,
    active: true,
    created_at: 1736033565,
  },
];

export const flowsList = [
  {
    id: 1,
    name: 'Lead Qualification Flow',
    description:
      'Structured conversation flow for qualifying sales leads, gathering contact information, and routing to appropriate sales teams.',
    flow_type: 'lead_qualification',
    active: true,
    created_at: 1736033561,
  },
  {
    id: 2,
    name: 'Customer Support Triage',
    description:
      'Multi-step flow that categorizes support requests, provides automated solutions, and escalates when needed.',
    flow_type: 'support',
    active: true,
    created_at: 1736033562,
  },
  {
    id: 3,
    name: 'Appointment Booking',
    description:
      'Interactive flow for scheduling appointments, checking availability, and sending confirmation details.',
    flow_type: 'appointment',
    active: true,
    created_at: 1736033563,
  },
  {
    id: 4,
    name: 'Order Status Check',
    description:
      'Flow for retrieving order information, providing tracking details, and handling delivery queries.',
    flow_type: 'order_tracking',
    active: false,
    created_at: 1736033564,
  },
  {
    id: 5,
    name: 'Feedback Collection',
    description:
      'Guided conversation flow for collecting customer feedback, ratings, and improvement suggestions.',
    flow_type: 'feedback',
    active: true,
    created_at: 1736033565,
  },
];
